import { biggerOrTo } from '../../render-helper';

const titleMap: { [key: string]: string } = {
  counts: 'Video Counts',
  engagements: 'Video Engagement',
  views: 'Video Views',
  likes: 'Video Likes',
  comments: 'Video Comments',
  shares: 'Video Shares',
  time: 'Date',
  channel: 'Channel',
  engagement_per_view: 'Video Engagement Rate',
};

export default function videoChartColumns(params: any) {
  const metrics = params?.metrics || [];
  const splitList = params?.group_bys || [];

  const columns = [];

  if (splitList.length > 0) {
    columns.push(
      ...splitList.map((item: string) => {
        const title = titleMap[item] || item;
        return { header: title, render: item };
      }),
    );
  }
  if (metrics.length > 0) {
    const haShare = splitList.includes('channel');
    const engagementRate = [
      'engagements',
      'engagement_per_view',
    ].every(metric => metrics.includes(metric));

    columns.push(
      ...metrics
        .map((item: string) => {
          if (engagementRate && item === 'engagement_per_view') {
            return [];
          }
          const title = titleMap[item] || item;
          const metricColumn = {
            render: item,
            header: title,
            numFmt: item === 'engagement_per_view' ? '0.00%' : '#,##',
            renderHelper: item === 'engagement_per_view' ? [] : [biggerOrTo(0, '-')],
          };

          if (engagementRate && item === 'engagements') {
            return [
              metricColumn,
              { render: 'engagement_per_view', header: 'Video Engagement Rate', numFmt: '0.00%' },
            ];
          }

          return haShare && item !== 'engagement_per_view' ? [
            metricColumn,
            { render: `${item}_share`, header: `${title} Share%`, numFmt: '0.00%' },
          ] : [metricColumn];
        })
        .flat(3),
    );
  }
  return columns;
}
